import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { FiAlertCircle } from "react-icons/fi";
import { goToCompanyList, goToLogin } from "../../../../routes/coordinator";
import { GRAY, GRAY_LIGHT, REDMONEDD, WHITE } from "../../../../constants/colors";
import Company from "../../../../services/companyApi";
import { useRecoilState, useSetRecoilState } from "recoil";
import { selectedCompany } from "../../../../atoms/selectedCompany";
import { toast } from "react-toastify";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import ClientApi from "../../../../services/clientApi";

const DeleteAccount = ({ isOpen, setIsOpen, idClient, idAccount }: any) => {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();

  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];

  const [companyDelete, setCompanyDelete] = useState({
    id: 0,
    nome: "",
    razaoSocial: "",
    cnpj: "",
  });

  const onClose = () => {
    setIsOpen(false);
  };

  // async function getAccountId() {
  //   try {
  //     const response = await ClientApi.get(idClient, idAccount);
  //     setCompanyDelete(response);
  //     //   console.log("response no modal de deletar", response);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  // useEffect(() => {
  //   getAccountId();
  // }, [idAccount]);

  async function deleteAccount() {
    try {
      await ClientApi.deleteClientAccountPerId(idClient, idAccount);
      toast.success("Conta deletada com sucesso!");
      setRefreshGlobal(refresh + 1);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            w={"100%"}
            h={"110px"}
          >
            {<FiAlertCircle color={REDMONEDD} size={70} />}
          </Box>
          <ModalBody>
            <Box
              h={"70px"}
              justifyContent={"center"}
              textAlign={"center"}
              alignContent={"center"}
            >
              <Text fontSize="2xl">
                Deseja excluir a conta{ companyDelete.nome}?
              </Text>
            </Box>
          </ModalBody>

          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              background={GRAY_LIGHT}
              mr={3}
              onClick={() => {
                setCompanyDelete({
                  id: 0,
                  nome: "",
                  razaoSocial: "",
                  cnpj: "",
                });
                onClose();
              }}
            >
              Cancelar
            </Button>
            <Button
              background={REDMONEDD}
              color={WHITE}
              onClick={() => {
                deleteAccount();
                onClose();
              }}
            >
              Deletar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DeleteAccount;
